let _appConfig = {}

export const setDefaultAppConfig = appConfig => {
  _appConfig = appConfig
}

// default {} since the backoffice does not have a default app config
export const getDefaultAppConfig = () => _appConfig || {}
